import '../DeckNav.css';
import { FamilyDeckFace } from '../../DeckCardOverviews/BasicWords/FamilyOv';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import ResourceBar from '../../Components/Resource/ResourceBar';
import Footer from '../../Components/Footer/Footer';


export default function FamilyNav() {
  return (
<div>
  <SPLoader time={0.6}/>
  <HeaderNav GoBack_to={"/BasicWordsNav"}/>
  <h1 className="DeckTitle-nav">Family (가족)</h1>
  <ResourceBar DeeperLook_to="/FamilyDLook" Dictionary_to="/FamilyDictionary"/>
  <h1 className="Header2-nav">Flashcards</h1>
   <div><DeckNav faceCard={FamilyDeckFace} title_input=""/> </div>
   <Footer/>
</div>
  )
}